module.exports = __webpack_public_path__ + "static/img/hd.17ac0e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hd.jpg
// module id = 3L7W
// module chunks = 1